import React, { useContext } from "react";

import "./ModeBar.css";

// all the png assets for the mode buttons
import movemode from "../../assets/move-mode.png"
import rectanglemode from "../../assets/rectangle-mode.png"
import ellipsemode from "../../assets/ellipse-mode.png"
import linemode from "../../assets/line-mode.png"
import textmode from "../../assets/text-mode.png"
import controlContext from "../../contexts/control-context";
import undoImg from "../../assets/undo.png";
import redoImg from "../../assets/redo.png"

const ModeBar = () => {

    // functions related to changing modes and connecting to the command palette
    // should probably go here (as well as state stuff)
    const {
        currMode,
        changeCurrMode,
        selectedShapeId,
        selectShape,
        undo,
        redo,
        undoable,
        redoable,
    } = useContext(controlContext);

    return (
        // all the mode buttons in the navigation bar
        <div id="mode-bar">
            <button type="button" className="mode-button" style={currMode==="select"  ? {outline: "solid gray"} : null} onClick={() => {changeCurrMode("select"); }}><img src={movemode} alt="move mode button"/></button>
            <button type="button" className="mode-button" style={currMode==="rect"    ? {outline: "solid gray"} : null} onClick={() => {changeCurrMode("rect");    selectShape(undefined); }}><img src={rectanglemode} alt="rectangle mode button"/></button>
            <button type="button" className="mode-button" style={currMode==="ellipse" ? {outline: "solid gray"} : null} onClick={() => {changeCurrMode("ellipse"); selectShape(undefined); }}><img src={ellipsemode} alt="ellipse mode button"/></button>
            <button type="button" className="mode-button" style={currMode==="line"    ? {outline: "solid gray"} : null} onClick={() => {changeCurrMode("line");    selectShape(undefined); }}><img src={linemode} alt="line mode button"/></button>
            <button type="button" className="mode-button" style={currMode==="text"    ? {outline: "solid gray"} : null} onClick={() => {changeCurrMode("text");    selectShape(undefined); }}><img src={textmode} alt="text mode button"/></button>
            <button type="button" className="mode-button" onClick={() => undo()} disabled={!undoable}><img src={undoImg} alt="undo button"/></button>
            <button type="button" className="mode-button" onClick={() => redo()} disabled={!redoable}><img src={redoImg} alt="redo button"/></button>
        </div>
    )

}

export default ModeBar;